import http from "@/http/aisea/axios";

const resource = "/voyage_history";

export default {
  fetchVoyageHistoryList(payload) {
    return http.get(`${resource}`, {
      params: {
        limit: payload.limit,
        start: payload.start
      }
    });
  },

  fetchVoyageHistoryDetail(id) {
    return http.get(`${resource}/${id}`);
  },
};
